import { func, object, string } from 'prop-types';
import React from 'react';
import { GoDiffAdded } from 'react-icons/go';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import getMappings from '../mappings';

function CreateDialogContent({ type, toggle, onSuccess, addProps }) {
  const { add: AddForm } = getMappings()[type];
  return (
    <>
      <ModalHeader toggle={toggle}>Create new {type}</ModalHeader>
      <ModalBody>
        <AddForm onSuccess={onSuccess} {...addProps} />
      </ModalBody>
    </>
  );
}

CreateDialogContent.propTypes = {
  type: string.isRequired,
  toggle: func.isRequired,
  onSuccess: func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  addProps: object,
};

CreateDialogContent.defaultProps = {
  addProps: {},
};

const CreateDialog = createModalToggle(
  <GoDiffAdded />,
  CreateDialogContent,
  {
    color: 'default',
    className: 'd-inline-block pt-0',
    size: 'sm',
  },
  { size: 'lg' },
);
export default CreateDialog;
